import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable, of, Subscription } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { DatePipe } from '@angular/common';
import { PractitionRole, selectPractitionRoleById } from '../../../../../../core/lists';
import { AppState } from '../../../../../../core/reducers';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'kt-role-view-dialog-dialog',
  templateUrl: './role-view-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
})
export class RoleViewDialogComponent implements OnInit, OnDestroy {
  constructor(
    public dialogRef: MatDialogRef<RoleViewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private datePipe: DatePipe,
    private translate: TranslateService,
    private store: Store<AppState>,
  ) {}

  practitionRole: PractitionRole;
  practitionRole$: Observable<PractitionRole>;
  hasFormErrors = false;
  viewLoading = false;
  loadingAfterSubmit = false;
  private componentSubscriptions: Subscription;
  description;
  availability = [];

  ngOnInit() {
    if (this.data.practitionRoleId) {
      this.practitionRole$ = this.store.pipe(
        select(selectPractitionRoleById(this.data.practitionRoleId)),
      );
    } else {
      const newPractitionRole = new PractitionRole();
      newPractitionRole.clear();
      this.practitionRole$ = of(newPractitionRole);
    }
    this.practitionRole$.subscribe((res) => {
      if (!res) {
        return;
      }
      this.practitionRole = new PractitionRole();
      this.practitionRole.id = res.id;
      this.practitionRole.code = this.getCode(res.code);
      this.practitionRole.active = res.active;
      this.practitionRole.period_start = res.period['start'];
      this.practitionRole.period_end = res.period['end'];
      this.practitionRole.specialty = res.specialty;
      this.practitionRole.notAvailable = res.notAvailable;
      this.practitionRole.availabilityExceptions = res.availabilityExceptions;
      this.practitionRole.availableTime = res.availableTime;

      this.getAvailabletime(this.practitionRole.availableTime);
    });
  }

  ngOnDestroy() {
    if (this.componentSubscriptions) {
      this.componentSubscriptions.unsubscribe();
    }
  }

  preparePractitionRole(): PractitionRole {
    const _practitionRole = new PractitionRole();
    _practitionRole.id = this.practitionRole.id;
    _practitionRole.active = this.practitionRole.active;
    _practitionRole.period_start = this.practitionRole.period_start;
    _practitionRole.period_end = this.practitionRole.period_end;
    _practitionRole.code = this.practitionRole.code;
    _practitionRole.specialty = this.practitionRole.specialty;
    _practitionRole.notAvailable_description = this.practitionRole.notAvailable_description;
    _practitionRole.notAvailable_during_start = this.practitionRole.notAvailable_during_start;
    _practitionRole.notAvailable_during_end = this.practitionRole.notAvailable_during_end;
    _practitionRole.availabilityExceptions = this.practitionRole.availabilityExceptions;
    _practitionRole.availableTime = this.practitionRole.availableTime;
    return _practitionRole;
  }

  getItemCssClassByStatus(is_active = false): string {
    switch (is_active) {
      case false:
        return 'danger';
      case true:
        return 'success';
    }
  }

  getItemStatusString(is_active = false): string {
    switch (is_active) {
      case false:
        return this.translate.instant('GLOBAL.INACTIVE');
      case true:
        return this.translate.instant('GLOBAL.ACTIVE');
    }
  }

  getPeriodStart(period) {
    if (period != null && period !== '') {
      return period.start;
    } else {
      return '';
    }
  }

  getPeriodEnd(period) {
    if (period != null && period !== '') {
      return ' To ' + period.end;
    } else {
      return '-';
    }
  }

  getCode(code) {
    if (code != null && code.length !== 0) {
      return code[0].coding[0].display;
    } else {
      return '-';
    }
  }

  getAvailableTime(av_tim) {
    if (av_tim != null && av_tim.length !== 0) {
      return av_tim[0].daysOfWeek + ',' + av_tim[1].daysOfWeek;
    } else {
      return '-';
    }
  }

  getSpecialty(specialty) {
    if (specialty != null && specialty.length !== 0) {
      return specialty[0].coding[0].display;
    } else {
      return '-';
    }
  }

  getStartNotAvailable(notAvailable) {
    if (notAvailable != null && notAvailable.length !== 0) {
      return notAvailable[0]['during'].start;
    } else {
      return '-';
    }
  }
  getEndNotAvailable(notAvailable) {
    if (notAvailable != null && notAvailable.length !== 0) {
      return notAvailable[0]['during'].end;
    } else {
      return '-';
    }
  }

  getDescNotAvailable(notAvailable) {
    if (notAvailable != null && notAvailable.length !== 0) {
      return notAvailable[0].description;
    } else {
      return '-';
    }
  }

  getAvailabletime(availableTime) {
    for (let i = 0; i < availableTime.length; i++) {
      if (availableTime[i] != null && availableTime.length !== 0) {
        this.availability.push(
          availableTime[i]['daysOfWeek'] +
            ' From ' +
            availableTime[i]['availableStartTime'] +
            ' To ' +
            availableTime[i]['availableEndTime'],
        );
      }
    }
  }
}
